import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { includes, product } from '../data/ebook';
import { BuyButton, PRICE_ANCHOR_ID } from './BuyButton';
import { Section } from './Section';
export function Offer() {
  return <Section id="comprar" className="bg-sage-dark text-white" data-id="element-127" data-mp="1mmz95ra5cgxs">
      <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-128" data-mp="1ho5z68u2j82d">
        <div data-id="element-129" data-mp="tyv1j080ltsg">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-light" data-id="element-130" data-mp="tybn3thkpnj6">
            {product.audience}
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight sm:text-5xl" data-id="element-131" data-mp="p1bf3d15yapf">
            El próximo lunes ese jean te queda flojo otra vez.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-sage-light" data-id="element-132" data-mp="yxoix3qfa4xw">
            Descarga la guía completa hoy y empieza el Día de Reinicio mañana por la mañana.
          </p>

          <ul className="mt-9 grid gap-3.5 sm:grid-cols-2" data-id="element-133" data-mp="2admlqpv0buqo">
            {includes.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-white/90" data-id="element-134" data-mp="pkqo4apfpvaa">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-sage-light" aria-hidden="true" data-id="element-135" data-mp="uisgxncnx8yy" />
                {item}
              </li>)}
          </ul>
        </div>

        <div id={PRICE_ANCHOR_ID} className="flex scroll-mt-24 flex-col justify-center rounded-lg bg-white p-8 text-ink sm:p-10" data-id="element-136" data-mp="13k01l2m9abak">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-137" data-mp="6vamfk20jwsa">
            Acceso completo · Pago único
          </p>
          <div className="mt-4 flex items-baseline gap-3" data-id="element-138" data-mp="fufjsn1u9k2v">
            <span className="font-display text-6xl leading-none text-ink" data-id="element-139" data-mp="fsukkk4kxcyo">${product.price}</span>
            <span className="text-lg text-muted line-through" data-id="element-140" data-mp="kmp3hlcd1nwp">${product.compareAt}</span>
          </div>
          <p className="mt-2 text-sm text-muted" data-id="element-141" data-mp="3k8dmwz0ysrps">
            {product.currency} · sin suscripciones, tuyo para siempre
          </p>

          <BuyButton isCheckout className="mt-8 w-full" data-id="element-142" data-mp="vfqvvyra56qm">
            Descargar ahora
          </BuyButton>

          <div className="mt-7 flex gap-3 border-t border-line pt-6" data-id="element-143" data-mp="qgxfnyklz1mr">
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-144" data-mp="qejlrt1nzvgs" />
            <p className="text-sm leading-relaxed text-muted" data-id="element-145" data-mp="157mtz9td8wuu">
              <span className="font-semibold text-ink" data-id="element-146" data-mp="107s51bt5ihcf">Garantía de 7 días.</span> Si sigues el
              protocolo y no notas diferencia, escríbenos y te devolvemos el 100%.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}